<template>
  <div class="card">
      <div class="card-body">
          <div class="flex justify-between align-items-center">
              <div class="d-block align-self-center">
                  <h4 class="card-title">Verlofaanvraag</h4>
                  <span>Plaats een nieuwe aanvraag voor verlof.</span>
                  <p>Controleer je uren goed! Haaer maakt alleen een schatting van het aantal uur.</p>
              </div>
              <a class="btn btn-secondary btn-sm" :href="back"><i class="fas fa-chevron-left pr-2"></i> Terug</a>
          </div>
          <div class="">
              <hr class="hr-style">
          </div>
          <div class="flex mt-3" v-if="profiles">
              <div class="w-1/3">
                  <div class="form-group">
                      <label>Werknemer</label>
                      <select name="employee" class="form-control custom-select" v-bind:class="{'is-invalid' : this.errors && this.errors['employee']}" v-model="profile" @change="loadProfile">
                          <option :value="null">-- Selecteer werknemer --</option>
                          <option v-for="profile in profiles" :key="profile.id" :value="profile.id" :selected="old.employee === profile.id">{{ profile.fullName }}</option>
                      </select>
                      <small v-if="this.errors && this.errors['employee']" class="d-block text-danger pt-1">{{ this.errors['employee'][0] }}</small>
                  </div>
              </div>
          </div>
          <div class="flex" v-show="employeeSelected || !profiles">
              <div class="w-1/3">
                  <div>
                      <label>Soort verlof</label>
                      <select class="form-control custom-select" v-bind:class="{'is-invalid' : this.errors && this.errors['type']}" name="type" v-model="absence.type">
                          <option :value="null">-- Selecteer verlofsoort --</option>
                          <option v-for="type in types" :key="type.key" :value="type.value" :selected="old.type ? (old.type == type.value) : (absence.type == type.value)">{{ type.key }}</option>
                      </select>
                      <small v-if="this.errors && this.errors['type']" class="d-block text-danger pt-1">{{ this.errors['type'][0] }}</small>
                  </div>
              </div>
          </div>
          <div class="mt-3" v-show="employeeSelected || !profiles">
              <hr class="hr-style">
          </div>
          <div class="flex mt-4" v-show="employeeSelected || !profiles">
              <div class="w-1/2 pr-4 vr-style">
                  <div class="flex flex-wrap">
                      <div class="form-group w-full">
                          <label>Start- / Einddatum</label>
                          <VueDatePicker
                          :is-date-range="true"
                          :is-multiple-date-range="true"
                          v-model="calendarData"
                          locale="nl-NL"
                          :dayNames="dayNames"
                          :monthNames="monthNames"
                          placeholder="Select Date Range"
                          :format="DD-MM-YYYY - DD-MM-YYYY" :enable-time-picker="false" range inline auto-apply>
                          </VueDatePicker>
                          <small v-if="this.errors && this.errors['start_date']" class="block text-danger pt-1">{{ this.errors['start_date'][0] }}</small>
                          <small v-if="this.errors && this.errors['end_date']" class="block text-danger">{{ this.errors['end_date'][0] }}</small>
                      </div>
                      <input type="hidden" name="ranges" :value="this.ranges">
                      <small v-if="this.errors && this.errors['ranges']" class="block text-danger pt-1">{{ this.errors['ranges'][0] }}</small>
                  </div>

                  <div class="row" v-for="range in ranges" v-if="ranges.length > 0">
                      <div class="table-responsive pt-2">
                          <table class="table table-striped">
                              <thead>
                                  <tr>
                                      <th>Datum</th>
                                      <th>Tijd</th>
                                      <th>Aantal Uren</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr v-for="date in range.dates">
                                      <td>
                                          {{ date['day'] }}
                                          <div v-if="date.in_use || date.holiday != false || date.workday == false" style="display: inline-block;">
                                              <div class="info-circle-wrap" @mouseenter="mouseEnter(date)" @mouseout="mouseOut(date)">
                                                  <div class="info-circle" @mouseenter="mouseEnter(date)">
                                                      <span class="info-text" @mouseenter="mouseEnter(date)">!</span>
                                                  </div>
                                              </div>
                                              <div class="info-pop-up-wrap" v-show="date.hover">
                                                  <div class="info-pop-up" v-if="date.holiday != false || date.workday == false">
                                                      <h5 class="text-primary">
                                                          Uren zijn naar 0 gezet, reden:
                                                      </h5>
                                                      <ul>
                                                          <li v-if="date.holiday != false">
                                                              Vrij wegens {{ date.holiday }}
                                                          </li>
                                                          <li v-if="date.workday == false">
                                                              Dit is geen werkdag in je weekplanning
                                                          </li>
                                                      </ul>
                                                  </div>
                                                  <div class="info-pop-up" v-if="date.in_use">
                                                      <h5 class="text-primary">
                                                          Let op!
                                                      </h5>
                                                      <ul>
                                                          <li>
                                                              Deze datum is al geselecteerd
                                                          </li>
                                                      </ul>
                                                  </div>
                                              </div>
                                          </div>
                                      </td>
                                      <td v-if="!date['edit']"><i class="far fa-clock"></i> {{ date['time']['from'] }} - {{ date['time']['to'] }} <i class="fas fa-pencil-alt" v-on:click="date['edit'] = true" @click="newEdit(range, date)"></i></td>
                                      <td v-if="date['edit']">
                                          <div class="flex">
                                              <input class="form-control form-control-sm edit-time p-2" type="text" placeholder="09:00" v-model="date['time']['from']" @change="editTime($event, range, date, date['time']['from'])">
                                              <label class="p-2 align-middle">-</label>
                                              <input class="form-control form-control-sm edit-time p-2" type="text" placeholder="17:00" v-model="date['time']['to']" @change="editTime($event, range, date, date['time']['to'])">
                                              <button type="button" class="btn btn-light btn-sm ml-1" @click="turnEditOff(date)"><i class="fas fa-save"></i></button>
                                          </div>
                                          <div class="flex">
                                              <input class="form-control form-control-sm edit-time p-2" type="text" placeholder="30" v-model="date['time']['break']" @change="editTime($event, range, date, date['time']['break'])">
                                              <label class="p-2 align-middle">minuten onbetaalde pauze</label>
                                          </div>
                                      </td>
                                      <td>{{ date['hours'] }}</td>
                                  </tr>
                              </tbody>
                          </table>
                      </div>
                      <hr class="hr-style">
                      <div class="flex w-full">
                          <div class="">
                              <div class="w-full">
                                  <label>
                                      Op te nemen uren:
                                      <span style="color: white; border-radius: 5px; background: #7E60D5; padding: 2px 7px 2px 7px;">
                                          {{ range.absencehours }}
                                      </span>
                                  </label>
                              </div>
                              <div class="w-full">
                                  <small v-if="this.errors && this.errors['hours']" class="d-block text-danger pt-1">{{ this.errors['hours'][0] }}</small>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>


              <div class="w-1/2 pl-4">
                  <span class="block pb-3">
                      <h5>Je wilt <span style="color: white; border-radius: 5px; background: #7E60D5; padding: 2px 7px 2px 7px;">{{ absence.hours }}</span> uur opnemen.</h5>
                  </span>
                  <input type="hidden" name="hours" v-model="absence.hours"/>
                  <span class="block pb-3">
                      <strong>Bepaal de inzet van je uren</strong>
                  </span>
                  <div class="block pb-3">
                      <small v-if="this.errors && this.errors['jars']" class="d-block text-danger pt-1">{{ this.errors['jars'][0] }}</small>
                  </div>
                  <div class="flex align-items-center mt-1" v-for="(jar, index) in jars" v-bind:key="index">
                      <div class="flex-grow-1">
                          <span>{{ jar.name }}</span>
                          <div v-if="jar.name === 'Tijd voor tijd overuren'" style="display: inline-block;">
                              <div class="info-circle-wrap">
                                  <div class="info-circle">
                                      <span class="info-text">?</span>
                                  </div>
                              </div>
                              <div class="info-pop-up-wrap info-pop-up-wrap--hide">
                                  <div class="info-pop-up">
                                      <p class="mb-0">
                                          Compensatie van extra gewerkte uren krijg je terugbetaalt in tijd niet in gelden
                                      </p>
                                  </div>
                              </div>
                          </div>

                          <br>
                          <small><strong>{{ (Math.round((jar.available + Number.EPSILON) * 100) / 100).toString().split('.')[0] || 0 }}</strong> uur en <strong>{{ Math.round((Math.round((jar.available + Number.EPSILON) * 100) / 100).toString().split('.')[1] / 100 * 60) || 0 }}</strong> minuten resterend</small>
                      </div>
                      <div>
                          <input type="text" class="form-control" style="width: 60px" v-model="jar.using" @change="validateJarUsage(index, $event.target.value)" />
                      </div>
                      <div>
                          <button type="button" class="btn btn-primary ml-1" @click="removeJarHour(index)" :disabled="checkRemoveHoursJars(index)">
                              <i class="fas fa-chevron-down"></i>
                          </button>
                      </div>
                      <div>
                          <button type="button" class="btn btn-primary ml-1" @click="addJarHour(index)" :disabled="checkAddHoursJars(index)">
                              <i class="fas fa-chevron-up"></i>
                          </button>
                      </div>
                  </div>
                  <div class="form-group pt-5">
                      <label>Omschrijving / notitie</label>
                      <textarea class="form-control" v-bind:class="{'is-invalid' : this.errors && this.errors['explanation']}" name="explanation" rows="10" v-model="absence.explanation"></textarea>
                      <small v-if="this.errors && this.errors['explanation']" class="d-block text-danger pt-1">{{ this.errors['explanation'][0] }}</small>
                  </div>
                  <div class="block text-right">
                        <button type="button" @click="submit()" class="btn btn-secondary">Aanvraag indienen</button>
                    </div>
              </div>

          </div>
      </div>
  </div>
</template>

<script>

import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import moment from 'moment';
import axios from 'axios';

const STEP_SIZE = 1;

    export default {
        components: { VueDatePicker },
        props: {
            old: {},
            absence: {
                type: Object,
                default: function () {
                    return {
                        hours: 0,
                        start_date: moment().format('DD-MM-YYYY'),
                        end_date: moment().add(2, 'hours').format('DD-MM-YYYY'),
                        type: null,
                        explanation: "",
                    }
                }
            },
            employeeRequired: {
                type: Boolean,
                default: false
            },
            profileJars: {
                type: Array
            },
            profiles: {
                type: Object,
            },
            types: {
                type: Object,
            },
            back: {
                type: String,
                default: '/',
            }
        },
        data: function () {
            return {
                jars: [],
                calendarData: {},
                ranges: [],
                errors: {},
                dayNames: [
                    'Ma',
                    'Di',
                    'Wo',
                    'Do',
                    'Vr',
                    'Za',
                    'Zo',
                ],
                monthNames: [
                    'Januari',
                    'Februari',
                    'Maart',
                    'April',
                    'Mei',
                    'Juni',
                    'Juli',
                    'Augustus',
                    'September',
                    'Oktober',
                    'November',
                    'December',
                ],
                prevHours: 0,
                profile: null,
                employeeSelected: false,
                holidays: [],
                workDays: [],
            }
        },
        mounted: function()
        {
            // Overwrite if there are employee jars.
            if (this.profileJars) {
                this.jars = this.profileJars;
            }

            // Start Date
            this.absence.start_date = this.old.start_date ? this.old.start_date : moment().format('DD-MM-YYYY HH:mm');

            // End Date
            this.absence.end_date = this.old.end_date ? this.old.end_date : moment().add(1, 'hours').format('DD-MM-YYYY HH:mm');

            this.absence.explanation = this.old.explanation ? this.old.explanation : this.absence.explanation;
            this.absence.hours = this.old.hours ? this.old.hours : this.absence.hours;

            for (let i = 0; i < this.jars.length; i++) {
                this.jars[i].remaining = this.jars[i].available;
            }

            axios.get('/employee/absence/holidays').then((response) => {
                this.holidays = response.data.holidays;
            });

            axios.get('/employee/absence/workdays').then((response) => {
                this.workDays = response.data.workDays;
            });
        },
        computed: {
            availableLeaveHours() {
                let usingHours = 0;
                if (this.absence.hours || this.absence.hours.length) {
                    usingHours = parseFloat(this.absence.hours);
                }
                if (this.jars && this.jars.length) {
                    return this.jars.reduce((currentValue, jar) => currentValue + jar.available, 0) - usingHours;
                }
                return 0;
            },
            hours() {
                return this.absence.hours;
            }
        },
        watch: {
            hours: {
                handler: function (val) {
                    if (val === 0) {
                        this.absence.hours = 0;
                    }

                    if (val !== this.prevHours) {
                        this.calculateBest();
                        this.prevHours = val;
                    }
                },
                deep: true
            },
            calendarData: {
                handler: function (val) {
                    this.updateRanges(val);
                },
                deep: true
            }
        },
        methods: {
            loadProfile: function() {
                axios.get('/employer/absences/create', {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    params: {
                        profileId: this.profile,
                    }
                }).then((response) => {
                    this.jars = response.data.jars;
                    this.employeeSelected = true;

                    axios.get('/employee/absence/workdays/' + this.profile).then((response) => {
                        this.workDays = response.data.workDays;
                    });

                    if (this.ranges.length > 0) {
                        this.calculateBest();
                    }
                }).catch((error) => {
                    this.errors = error.response.data.errors;
                });
            },
            validateJarUsage(index, value) {
                let amount = parseFloat(value);
                if (isNaN(amount) || amount < 0) {
                    amount = 0;
                } else if (amount > this.jars[index].available) {
                    amount = this.jars[index].available;
                } else if (amount > this.absence.hours) {
                    amount = this.absence.hours;
                }
                this.jars[index].using = amount;
                this.validateTotalJarUsage();
            },
            validateTotalJarUsage() {
                let totalUsed = this.jars.reduce((acc, jar) => acc + parseFloat(jar.using), 0);
                if (totalUsed > this.absence.hours) {
                    let excess = totalUsed - this.absence.hours;
                    this.distributeExcess(excess);
                }
            },
            distributeExcess: function(excess, excludeIndex) {
                let redistributed = false;
                for (let i = 0; i < this.jars.length; i++) {
                    if (i === excludeIndex || excess <= 0) continue; // Skip the current jar

                    let currentUsing = this.jars[i].using;
                    if (currentUsing > excess) {
                        this.jars[i].using -= excess;
                        this.jars[i].using = parseFloat(this.jars[i].using.toFixed(2));
                        excess = 0;
                        redistributed = true;
                        break; // Stop the loop as the excess has been fully subtracted
                    } else if (currentUsing > 0) {
                        excess -= currentUsing;
                        this.jars[i].using = 0; // This jar's used amount is fully subtracted
                        redistributed = true;
                    }
                }
                return redistributed; // Return true if redistribution was successful, false otherwise
            },
            reallocateShortfall: function(shortfall, excludeIndex) {
                this.jars.forEach((jar, index) => {
                    if (shortfall <= 0 || index === excludeIndex) return; // Exit if shortfall has been fully reallocated or if the jar is excluded

                    let availableCapacity = jar.available - jar.using;
                    if (availableCapacity > 0) {
                        let allocation = Math.min(availableCapacity, shortfall);
                        this.jars[index].using += allocation;
                        shortfall -= allocation; // Decrease shortfall by the allocated amount

                        this.jars[index].using = parseFloat(this.jars[index].using.toFixed(2));
                    }
                });

                if (shortfall > 0) {
                    this.jars[excludeIndex].using += shortfall;
                    // Round to two decimal places
                    this.jars[excludeIndex].using = parseFloat(this.jars[excludeIndex].using.toFixed(2));
                }

                this.$forceUpdate(); // Force update to reflect changes in the UI
            },
            hasOverlappingRange: function(values) {
                let startDate = moment(values.startDate);
                let endDate = moment(values.endDate);

                if (startDate.year() < endDate.year()) {
                    this.errors.push('Datums mogen niet overlappen.')
                }
            },
            updateRanges: function(values) {
                this.ranges = (this.ranges.length == null) ? [] : this.ranges;

                this.addNewRanges(values);
                this.checkAndRemoveRanges(values);
                this.checkDatesInUse();
                this.updateAbsenceHours();
                this.calculateBest();


                console.log(this.ranges);
            },
            addNewRanges: function(dateArray) {
                // for (let date of dateArray) {
                    let start = moment(dateArray[0]).format('DD-MM-YYYY');
                    let end = moment(dateArray[1]).format('DD-MM-YYYY');
                    // let start = "13-12-2023";
                    // let end = "15-12-2023";
                    let add = true;

                    console.log(start);
                    console.log(end);

                    for (let currentRange of this.ranges) {
                        add = (currentRange.start == start && currentRange.end == end) ? false : add;
                    }

                    (add) ? this.addRange(start, end) : null;
                // }
            },
            checkAndRemoveRanges(dateArray) {
                for (let currentRange of this.ranges) {
                    let remove = true;

                    //for (let date of dateArray) {
                        let start = moment(dateArray[0]).format('DD-MM-YYYY');
                        let end = moment(dateArray[1]).format('DD-MM-YYYY');
                        remove = (currentRange.start == start && currentRange.end == end) ? false : remove;
                    //}

                    if (remove) {
                        this.ranges.splice(this.ranges.indexOf(currentRange), 1);
                    }
                }
            },
            addRange: function(start, end) {
                let diff = this.calculateDiffDays(start, end);
                console.log("diff: "+ diff);
                let dates = [];
                for (let i = 0; i < diff; i++) {
                    this.addToDates(dates, start, i);
                }

                this.addToRanges(start, end, dates);
            },
            checkDatesInUse: function() {
                this.ranges.forEach(range => {
                    range.dates.forEach(date => {
                        date.in_use = (this.dateExists(date.day, range)) ? true : false;
                    });
                });
            },
            dateExists: function(value, ignoreRange) {
                let exists = false;
                this.ranges.forEach(range => {
                    if (ignoreRange.start != range.start && ignoreRange.end != range.end) {
                        range.dates.forEach(date => {
                            exists = (date.day == value) ? true : exists;
                        });
                    }
                });

                return exists;
            },
            addToRanges: function(start, end, dates) {
                this.ranges.push({
                    start: start,
                    end: end,
                    dates: dates,
                    absencehours: this.calculateDiffHours(dates)
                });

                this.ranges = [{
                    start: start,
                    end: end,
                    dates: dates,
                    absencehours: this.calculateDiffHours(dates)
                }]
            },
            addToDates: function(dates, start, i, in_use = false) {
                let date = String(moment(moment(start, "D/M/YYYY")).add(i, 'days').format('DD-MM-YYYY'));
                console.log("date: "+ date);
                let holidayFree = false;
                let holidayName = "";
                this.holidays.forEach((holiday) => {
                    if (holiday.date == date) {
                        holidayFree = true;
                        holidayName = holiday.text;
                    }
                });

                dates.push({
                    day: date,
                    time: {
                        from: (holidayFree) ? "00:00" : this.workDays[moment(date, "DD-MM-YYYY").isoWeekday()].start_time,
                        to: (holidayFree) ? "00:00" : moment(this.workDays[moment(date, "DD-MM-YYYY").isoWeekday()].start_time, "hh:mm").add(this.workDays[moment(date, "DD-MM-YYYY").isoWeekday()].hours, 'hours').format("HH:mm"),
                        break: (holidayFree) ? 0 : this.workDays[moment(date, "DD-MM-YYYY").isoWeekday()].break
                    },
                    hours: (holidayFree) ? 0 : this.workDays[moment(date, "DD-MM-YYYY").isoWeekday()].hours,
                    edit: false,
                    in_use: in_use,
                    holiday: (holidayFree) ? holidayName : false,
                    workday: this.workDays[moment(date, "DD-MM-YYYY").isoWeekday()].active,
                    hover: false
                });
            },
            calculateDiffHours: function(dates) {
                let tempHours = 0;
                dates.forEach(date => tempHours += date["hours"]);
                return tempHours;
            },
            calculateDiffDays: function(startDate, endEnd) {
                let start = moment(startDate, 'DD-MM-YYYY HH:mm');
                let end = moment(endEnd, 'DD-MM-YYYY HH:mm');
                return end.diff(start, 'days') + 1;
            },
            updateAbsenceHours: function() {
                this.absence.hours = 0;
                this.ranges.forEach((range, i) => {
                    this.absence.hours += range.absencehours;
                    this.absence.start_date = (i == 0) ? range.start : this.absence.start_date;
                    this.absence.end_date = (i == (this.ranges.length - 1)) ? range.end : this.absence.end_date;
                });
            },
            calculateBest: function() {
                let totalAbsenceHoursLeft = parseFloat(this.absence.hours);

                this.jars.forEach(jar => {
                    jar.using = 0; // Reset the using hours for each jar at the start
                    jar.remaining = jar.original; // Reset the remaining hours for each jar
                });

                for (let i = 0; i < this.jars.length && totalAbsenceHoursLeft > 0; i++) {
                    let jar = this.jars[i];
                    let available = jar.remaining;

                    if (available > 0) {
                        let allocation = Math.min(available, totalAbsenceHoursLeft);
                        jar.using += allocation;
                        jar.remaining -= allocation;
                        totalAbsenceHoursLeft -= allocation;

                        // Round jar.using to two decimal places after allocation
                        jar.using = parseFloat(jar.using.toFixed(2));
                    }
                }

                // If there are still absence hours left after allocating from all jars, add them to the first jar.
                // This is a fallback and should be adjusted based on your specific requirements.
                if (totalAbsenceHoursLeft > 0 && this.jars.length > 0) {
                    this.jars[0].using += totalAbsenceHoursLeft;
                    this.jars[0].remaining -= totalAbsenceHoursLeft;
                    totalAbsenceHoursLeft = 0;

                    // Ensure the final jar.using value is also rounded to two decimal places
                    this.jars[0].using = parseFloat(this.jars[0].using.toFixed(2));
                }

                this.$forceUpdate(); // Force update to reflect changes in the UI
            },
            addJarHour: function(index) {
                let totalUsed = this.jars.reduce((acc, jar) => acc + jar.using, 0);
                const totalRequested = parseFloat(this.absence.hours);

                // Check if adding STEP_SIZE hours exceeds the jar's available hours
                if (this.jars[index].using + STEP_SIZE > this.jars[index].available) {
                    console.log('Cannot add more hours. It exceeds the jar\'s available hours.');
                    return; // Prevent addition
                }

                // Check if total used hours already exceed or equal to total requested hours
                if (totalUsed >= totalRequested) {
                    // Attempt to redistribute hours from other jars
                    let excess = totalUsed + STEP_SIZE - totalRequested;
                    if (!this.distributeExcess(excess, index)) {
                        console.log('Cannot redistribute hours to add more to the selected jar.');
                        return; // Prevent addition if redistribution is not possible
                    }
                }

                // Add hours to the selected jar after successful redistribution or if total used hours do not exceed total requested hours
                this.jars[index].using += STEP_SIZE;
                // Round to two decimal places
                this.jars[index].using = parseFloat(this.jars[index].using.toFixed(2));

                if (this.jars[index].using > this.absence.hours && this.jars[index].using <= this.jars[index].available) {
                    this.jars[index].using = this.absence.hours;
                }

                this.$forceUpdate(); // Force update to reflect changes in the UI
            },
            removeJarHour: function(index) {
                if (this.jars[index].using <= 0) {
                    return; // Do not remove hours if the jar has 0 hours allocated
                }

                // Subtract hours from the selected jar
                this.jars[index].using -= STEP_SIZE;
                // Round to two decimal places
                this.jars[index].using = parseFloat(this.jars[index].using.toFixed(2));

                if (this.jars[index].using < 0) {
                    this.jars[index].using = 0;
                }

                // Check if total used hours fall below the total specified hours after subtraction
                let totalUsed = this.jars.reduce((acc, jar) => acc + jar.using, 0);
                if (totalUsed < this.absence.hours) {
                    // Calculate the shortfall in hours
                    let shortfall = this.absence.hours - totalUsed;

                    // Attempt to reallocate the shortfall to other jars with available capacity
                    this.reallocateShortfall(shortfall, index);
                }

                this.$forceUpdate(); // Force update to reflect changes in the UI
            },
            checkRemoveHoursJars: function(index) {
                // Step 1: Check if the current jar has no hours allocated
                if (this.jars[index].using <= 0) {
                    return true;
                }

                // Step 2 & 3: Check if any other jar's allocation has been modified
                for (let i = 0; i < this.jars.length; i++) {
                    if (i !== index && this.jars[i].original !== this.jars[i].using) {
                        return false; // Hours can be removed as another jar's allocation has been modified
                    }
                }

                // Step 4: No jars have modified allocations, so hours cannot be removed from the current jar
                return true;
            },
            checkAddHoursJars: function(index) {
                if (this.jars[index].using < this.jars[index].original && this.absence.hours !== this.jars[index].using) {
                    return false;
                }
                return true;
            },
            totalAvailable: function() {
                return this.jars.reduce((acc, jar) => acc + jar.available, 0);
            },
            totalJarAvailable: function(jar) {
                return jar.available;
            },
            calculateJarRemaining: function(jar) {
                let total = this.totalJarAvailable(jar);
                return total - jar.using;
            },
            editTime: function(event, currentRange, currentDate, toChange) {
                toChange = event.target.value;
                currentDate["hours"] = moment.duration(currentDate["time"]["to"]).asHours() - moment.duration(currentDate["time"]["from"]).asHours() - moment.duration(moment().hours(0).minutes(currentDate["time"]["break"]).format('HH:mm')).asHours();
                currentRange.absencehours = this.calculateDiffHours(currentRange.dates);
                this.updateAbsenceHours();
                this.calculateBest();
            },
            newEdit: function(currentRange, currentDate) {
                this.ranges.forEach(range => {
                    range.dates.forEach(date => date['edit'] = (range === currentRange && currentDate === date) ? true : false);
                });
            },
            submit: function() {
                axios.post('/absence/new-absence', {
                    ranges: this.ranges,
                    explanation: this.absence.explanation,
                    start: this.absence.start_date,
                    end: this.absence.end_date,
                    employee: this.profile,
                    employeeRequired: this.employeeRequired,
                    type: this.absence.type,
                    hours: this.absence.hours,
                    jars: this.jars,
                }).then(() => {
                    window.location.href = this.back;
                }).catch((error) => {
                    this.errors = error.response.data.errors;
                });
            },
            mouseEnter: function(date) {
                date.hover = true;
            },
            mouseOut: function(date) {
                date.hover = false;
            },
            turnEditOff: function($date) {
                $date['edit'] = false;
            },
        }
    }

</script>
